import { render, staticRenderFns } from "./ProjectsTypes.vue?vue&type=template&id=0dc4cd21&scoped=true"
import script from "./ProjectsTypes.vue?vue&type=script&lang=js"
export * from "./ProjectsTypes.vue?vue&type=script&lang=js"
import style0 from "./ProjectsTypes.vue?vue&type=style&index=0&id=0dc4cd21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc4cd21",
  null
  
)

export default component.exports